// extracted by mini-css-extract-plugin
export default {"modalHeaderContainer":"GroupModal_modalHeaderContainer__aCp6P","closeModal":"GroupModal_closeModal__TOLIZ","url":"GroupModal_url__GrP4Y"};